//Здесь, т.к. создаёт циклические ссылки
export var BuiltInSerial;
(function (BuiltInSerial) {
    BuiltInSerial["zero"] = "0000";
    BuiltInSerial["first"] = "0001";
    BuiltInSerial["second"] = "0002";
})(BuiltInSerial || (BuiltInSerial = {}));
